import React, { useEffect, useState } from "react";
import axios from "axios";
import appConstants from "../constants/appConstants";
import Layout from "../components/Layout";
import { Table, Button, Form, Spinner } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";

const getAuthToken = () => localStorage.getItem("authToken");

const TestMarksEntryPage = () => {
    const navigate = useNavigate();
  const { testId } = useParams(); // Assuming the testId is part of the URL
  const [students, setStudents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [updatedMarks, setUpdatedMarks] = useState({});

  const fetchTestMarks = async () => {
    const token = getAuthToken();
    if (!token) return;
    try {
      const response = await axios.get(
        `${appConstants.API_ROOT_URL}get-test-marks?test_id=${testId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response.data.status === "success") {
        const studentsData = response.data.students;
        setStudents(studentsData);
        const marksData = {};
        studentsData.forEach((student) => {
          marksData[student.student_id] = student.mark || "";
        });
        setUpdatedMarks(marksData);
      } else {
        console.error("Failed to fetch test marks:", response.data.message);
        setStudents([]);
      }
    } catch (error) {
      console.error("Error fetching test marks:", error);
      setStudents([]);
    } finally {
      setLoading(false);
    }
  };

  const handleMarkChange = (studentId, mark) => {
    setUpdatedMarks((prev) => ({
      ...prev,
      [studentId]: mark,
    }));
  };


  const saveMark = async (studentId, mark) => {
    const token = getAuthToken();
    if (!token) return;
  
    try {
      await axios.post(
        `${appConstants.API_ROOT_URL}save-single-test-mark`,
        { test_id: testId, student_id: studentId, mark },
        { headers: { Authorization: `Bearer ${token}` } }
      );
    } catch (error) {
      console.error(`Error saving mark for student ${studentId}:`, error);
    }
  };
  
  const handleInputEvent = (e, studentId) => {
    if (e.key === "Enter") {
      e.preventDefault();
      saveMark(studentId, updatedMarks[studentId]);
    }
  };
  
  const handleBlur = (studentId) => {
    saveMark(studentId, updatedMarks[studentId]);
  };

  const handleBackClick = () => {
    navigate(-1); // Goes back to the previous page
  };


  useEffect(() => {
    fetchTestMarks();
  }, [testId]);

  return (
    <Layout>
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "20px" }}>
        <h4>Enter Marks for Test</h4>
        <Button
          variant="secondary"
          onClick={handleBackClick}
          style={{ alignSelf: "flex-start" }}
        >
            <FaArrowLeft className="me-2" />
          Back
        </Button>
      </div>
      {loading ? (
        <Spinner animation="border" />
      ) : (
        <>
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>Sl</th>
                <th>Student</th>
                <th>Mark</th>
              </tr>
            </thead>
            <tbody>
              {students.map((student, index) => (
                <tr key={student.student_id}>
                  <td>{index + 1}</td>
                  <td>{student.name}</td>
                  <td>
                    <Form.Control
                        type="text"
                        value={updatedMarks[student.student_id] || ""}
                        onChange={(e) =>
                            handleMarkChange(student.student_id, e.target.value)
                        }
                        onBlur={() => handleBlur(student.student_id)}
                        onKeyDown={(e) => handleInputEvent(e, student.student_id)}
                        />

                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </>
      )}
    </Layout>
  );
};

export default TestMarksEntryPage;
